module.exports = __webpack_public_path__ + "img/logo-astec-white.23607012.svg";